var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReadSetW(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 12.5C13.7042 12.5 11.3551 10.5878 10.689 8H0V5H10.689C11.3551 2.41216 13.7042 0.5 16.5 0.5C19.8137 0.5 22.5 3.18629 22.5 6.5C22.5 9.81371 19.8137 12.5 16.5 12.5ZM25.5 5H30V8H25.5V5ZM9 27.5C6.20424 27.5 3.85509 25.5878 3.18903 23H0V20H3.18903C3.85509 17.4122 6.20424 15.5 9 15.5C12.3137 15.5 15 18.1863 15 21.5C15 24.8137 12.3137 27.5 9 27.5ZM18 23H30V20H18V23ZM12 21.5C12 23.1569 10.6569 24.5 9 24.5C7.34315 24.5 6 23.1569 6 21.5C6 19.8431 7.34315 18.5 9 18.5C10.6569 18.5 12 19.8431 12 21.5ZM19.5 6.5C19.5 8.15685 18.1569 9.5 16.5 9.5C14.8431 9.5 13.5 8.15685 13.5 6.5C13.5 4.84315 14.8431 3.5 16.5 3.5C18.1569 3.5 19.5 4.84315 19.5 6.5Z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadSetW);
export default __webpack_public_path__ + "static/media/readSetW.1255745904be274f84027fec37427cf0.svg";
export { ForwardRef as ReactComponent };